import React, { memo } from 'react';
import { Modal, Typography, Icon } from '@ann/web-components';
import {
  ModalHeaderContainer,
  ModalContentContainer,
  ItemWrapper,
} from './RemoveDocumentAccessModal.styled';

const getFileIcon = (type, extension) => {
  const ext = extension?.toLowerCase() || type?.toLowerCase() || '';
  if (ext.includes('pdf')) return 'pictureAsPdf';
  if (ext.includes('doc') || ext.includes('word')) return 'description';
  if (ext.includes('xls') || ext.includes('excel')) return 'tableChart';
  if (ext.includes('ppt') || ext.includes('presentation')) return 'slideshow';
  return 'description';
};

const RemoveDocumentAccessModal = ({
  isOpen,
  onClose,
  onConfirm,
  document,
  isLoading = false,
}) => {
  const handleConfirm = async () => {
    await onConfirm?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="medium" width="571px">
      <Modal.Header />
      <ModalHeaderContainer>
        <Typography category="title" size="medium" weight="bold">
          Are you sure you want to remove access?
        </Typography>
      </ModalHeaderContainer>
      <Modal.Body>
        <ModalContentContainer>
          <Typography category="body" size="medium" weight="regular" color="body">
            Your agent won't be able to use it for responses until you reconnect it.
          </Typography>
          {document && (
            <ItemWrapper>
              <Icon name={getFileIcon(document.type, document.extension)} />
              <Typography category="body" size="medium" weight="regular" color="body">
                {document.name || 'Unnamed Document'}
              </Typography>
            </ItemWrapper>
          )}
        </ModalContentContainer>
      </Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button 
          label="Cancel" 
          onClick={onClose} 
          type="secondary" 
          disabled={isLoading} 
        />
        <Modal.Button
          label={isLoading ? 'Removing...' : 'Remove access'}
          onClick={handleConfirm}
          disabled={isLoading}
        />
      </Modal.Actions>
    </Modal>
  );
};

RemoveDocumentAccessModal.displayName = 'RemoveDocumentAccessModal';

export default memo(RemoveDocumentAccessModal);

